import { useMemo } from 'react';

import { Matchup } from '@/entities';
import { extractTieBreakerInfo } from '@/infrastructure/utils/tieBreakerHelpers';

export const useTieBreakerMatch = (matchupData?: Matchup) => {
	return useMemo(() => extractTieBreakerInfo(matchupData), [matchupData]);
};
